import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DocumentInfo } from '../../document/models/document-info';
import { DocumentDetail } from '../models/document-detail';

@Component({
  selector: 'irar-file-upload',
  template: `
    <input id="file-upload" type="file" width="50px" (change)="fileChange($event)"/>
    <div>{{filename}}</div>
    <p-dialog [modal]="true" [showHeader]="false" [(visible)]="uploading">
    <div style="text-align:center">Uploading.  {{progress}}% Complete</div>
  </p-dialog>
  `
})
export class FileUploadComponent {

  @Output() uploadFile: EventEmitter<DocumentInfo> = new EventEmitter();
  @Input() uploading: boolean;
  @Input() progress: number;
  @Input() documentData: DocumentDetail;

  fileChange(event: any) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const doc = new DocumentInfo(this.documentId, file.name, file.name.substr(file.name.lastIndexOf('.') + 1), file.type, file);
      this.uploadFile.emit(doc);
    }
  }

  get documentId(){
    if (!this.documentData || !this.documentData.downloadId) { return 0; }
    return this.documentData.downloadId;
  }

  get filename() {
    if (!this.documentData) { return ''; }
    return this.documentData.filename;
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/file-upload.ts